interface ContainerActionsProps {
	readonly disabled?: boolean;
	readonly children: React.ReactNode;
}

const ContainerActionsLinksComponent = ({ disabled, children }: ContainerActionsProps) => {
	if (disabled) {
		return null;
	} else {
		return <>{children}</>;
	}
};

export { ContainerActionsLinksComponent };
